var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"8"}},[_c('h3',[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('v-col',{attrs:{"cols":"12","lg":"4"}},[(_vm.link)?_c('router-link',{attrs:{"to":_vm.link}},[_c('v-btn',{attrs:{"color":"primary","dark":""}},[_vm._v(_vm._s(_vm.buttonText))])],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }